module.exports = "data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7"


//////////////////
// WEBPACK FOOTER
// ./source/javascripts/vendor/admin/js/libs/jquery.tablesorteskin/asc.gif
// module id = 587
// module chunks = 7 8 9 10